import * as React from 'react';

const LogoAccessIcon = ({ id = 'access-icon', ...props }) => {
	const g0 = `${id}-g0`;
	const g1 = `${id}-g1`;
	const g2 = `${id}-g2`;
	const g3 = `${id}-g3`;
	const g4 = `${id}-g4`;

	return (
		<svg width={109} height={110} viewBox='0 0 478 478' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M477.956 60.5821V417.375C477.956 450.832 450.833 477.955 417.376 477.955H60.5823C27.1254 477.955 0 450.832 0 417.375V60.5821C0 27.1253 27.1254 0 60.5823 0H417.376C450.833 0 477.956 27.1253 477.956 60.5821Z'
				fill='#121210'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M308.282 111.744C278.772 111.744 254.962 135.66 254.962 165.088C254.962 194.515 278.772 218.431 308.282 218.431C337.681 218.431 361.601 194.515 361.601 165.088C361.601 135.66 337.681 111.744 308.282 111.744Z'
				fill={`url(#${g0})`}
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M335.583 230.932C370.243 230.932 398.342 259.011 398.342 293.673C398.342 320.529 398.342 349.899 398.342 368.453C398.342 373.447 396.36 378.243 392.828 381.749C389.295 385.287 384.51 387.272 379.515 387.272C344.865 387.272 271.381 387.272 236.732 387.272C231.738 387.272 226.95 385.287 223.419 381.749C219.888 378.243 217.905 373.447 217.905 368.453C217.905 349.899 217.905 320.529 217.905 293.673C217.905 259.011 246.003 230.932 280.664 230.932H335.583Z'
				fill={`url(#${g1})`}
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M316.409 230.932V387.272C316.409 387.272 265.32 387.272 236.726 387.272C231.732 387.272 226.944 385.287 223.413 381.749C219.882 378.243 217.898 373.447 217.898 368.453C217.898 349.899 217.898 320.529 217.898 293.673C217.898 277.036 224.51 261.062 236.28 249.288C248.05 237.546 264.013 230.932 280.658 230.932C300.045 230.932 316.409 230.932 316.409 230.932Z'
				fill={`url(#${g2})`}
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M170.084 98.661C140.574 98.661 116.764 122.577 116.764 152.005C116.764 181.432 140.574 205.348 170.084 205.348C199.482 205.348 223.402 181.432 223.402 152.005C223.402 122.577 199.482 98.661 170.084 98.661Z'
				fill={`url(#${g3})`}
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M197.383 217.847C232.043 217.847 260.142 245.948 260.142 280.608C260.142 328.817 260.142 387.276 260.142 387.276C260.142 387.276 144.765 387.276 98.5317 387.276C93.5382 387.276 88.7497 385.306 85.2187 381.757C81.6881 378.244 79.7046 373.441 79.7046 368.459C79.7046 347.276 79.7046 311.791 79.7046 280.608C79.7046 245.948 107.803 217.847 142.464 217.847H197.383Z'
				fill={`url(#${g4})`}
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M283.952 298.433C281.258 295.735 281.258 291.361 283.952 288.664C286.647 285.977 291.021 285.977 293.715 288.664L302.276 297.223L323.962 275.542C326.657 272.844 331.031 272.844 333.725 275.542C336.42 278.239 336.42 282.613 333.725 285.3L307.157 311.866C304.46 314.564 300.09 314.564 297.394 311.866L283.952 298.433Z'
				fill='#0CA3C1'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M145.751 285.317C143.057 282.62 143.057 278.246 145.751 275.548C148.446 272.861 152.82 272.861 155.514 275.548L164.074 284.107L185.761 262.426C188.456 259.728 192.83 259.728 195.524 262.426C198.218 265.124 198.218 269.498 195.524 272.184L168.956 298.75C166.259 301.448 161.889 301.448 159.193 298.75L145.751 285.317Z'
				fill='#0CA3C1'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M321 311.676V416.284C321 426.058 311.71 433.995 300.268 433.995H177.731C166.289 433.995 157 426.058 157 416.284V311.676C157 301.903 166.289 293.995 177.731 293.995H300.268C311.71 293.995 321 301.903 321 311.676Z'
				fill='#121210'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M283.427 328.042C283.427 334.001 277.763 338.836 270.787 338.836H208.949C201.972 338.836 196.308 334.001 196.308 328.042C196.308 322.088 201.972 317.253 208.949 317.253H270.787C277.763 317.253 283.427 322.088 283.427 328.042Z'
				fill='white'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M281.729 400.015C281.729 405.973 276.065 410.808 269.087 410.808H207.228C200.25 410.808 194.586 405.973 194.586 400.015C194.586 394.06 200.25 389.225 207.228 389.225H269.087C276.065 389.225 281.729 394.06 281.729 400.015Z'
				fill='white'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M267.711 352.331C267.711 358.29 262.047 363.125 255.069 363.125H239.353C232.375 363.125 226.711 358.29 226.711 352.331C226.711 346.377 232.375 341.542 239.353 341.542H255.069C262.047 341.542 267.711 346.377 267.711 352.331Z'
				fill='white'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M251.311 376.17C251.311 382.128 245.647 386.964 238.67 386.964H222.953C215.976 386.964 210.312 382.128 210.312 376.17C210.312 370.216 215.976 365.38 222.953 365.38H238.67C245.647 365.38 251.311 370.216 251.311 376.17Z'
				fill='white'
			/>
			<defs>
				<linearGradient
					id={g0}
					x1='339.692'
					y1='174.512'
					x2='339.692'
					y2='243.544'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#6ADFF6' />
					<stop offset='0.51' stopColor='#53D0E9' />
					<stop offset='1' stopColor='#0CA3C1' />
				</linearGradient>
				<linearGradient id={g1} x1='239.09' y1='300.42' x2='239.09' y2='398.865' gradientUnits='userSpaceOnUse'>
					<stop stopColor='#6ADFF6' />
					<stop offset='0.51' stopColor='#53D0E9' />
					<stop offset='1' stopColor='#0CA3C1' />
				</linearGradient>
				<linearGradient
					id={g2}
					x1='243.445'
					y1='309.085'
					x2='294.135'
					y2='309.085'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#0F839A' />
					<stop offset='0.58' stopColor='#0D99B5' stopOpacity='0.32' />
					<stop offset='1' stopColor='#0CA3C1' stopOpacity='0' />
				</linearGradient>
				<linearGradient
					id={g3}
					x1='201.493'
					y1='161.429'
					x2='201.493'
					y2='230.461'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#6ADFF6' />
					<stop offset='0.51' stopColor='#53D0E9' />
					<stop offset='1' stopColor='#0CA3C1' />
				</linearGradient>
				<linearGradient id={g4} x1='100.89' y1='293.153' x2='100.89' y2='399.84' gradientUnits='userSpaceOnUse'>
					<stop stopColor='#6ADFF6' />
					<stop offset='0.51' stopColor='#53D0E9' />
					<stop offset='1' stopColor='#0CA3C1' />
				</linearGradient>
			</defs>
		</svg>
	);
};

export default LogoAccessIcon;
